// Vencimentos (documentos e documentos CAC): rótulos e tons dos status derivados pelo backend.
// Os status NÃO são recalculados aqui — o backend manda `expiry_status`/`status` e `days_to_expire`.
import type { ExpiryStatus } from '@/types/document';
import type { CacDocStatus, ExpiringItem } from '@/types/cac';

/** Classe de badge (index.css) por status. */
export type BadgeTone = 'success' | 'warning' | 'danger' | 'neutral';

export const BADGE_CLASS: Record<BadgeTone, string> = {
  success: 'badge-success',
  warning: 'badge-warning',
  danger: 'badge-danger',
  neutral: 'badge-neutral',
};

export const EXPIRY_STATUS_LABELS: Record<Exclude<ExpiryStatus, 'none'>, string> = {
  ok: 'Em dia',
  expiring: 'Vencendo',
  expired: 'Vencido',
};

export const EXPIRY_STATUS_TONES: Record<Exclude<ExpiryStatus, 'none'>, BadgeTone> = {
  ok: 'success',
  expiring: 'warning',
  expired: 'danger',
};

export const CAC_STATUS_TONES: Record<CacDocStatus, BadgeTone> = {
  valid: 'success',
  expiring: 'warning',
  expired: 'danger',
  renewed: 'neutral',
};

/**
 * "vence em 23 dias" / "vence amanhã" / "vence hoje" / "vencido ontem" / "vencido há 5 dias".
 * Vazio para indefinido.
 */
export const describeDaysToExpire = (days?: number | null): string => {
  if (days === undefined || days === null || !Number.isFinite(days)) return '';
  if (days === 0) return 'vence hoje';
  if (days === 1) return 'vence amanhã';
  if (days > 1) return `vence em ${days} dias`;
  if (days === -1) return 'vencido ontem';
  return `vencido há ${-days} dias`;
};

/** Link do item de vencimento: documento CAC abre a edição em Documentos CAC; documento comum, em Documentos. */
export const expiringItemLink = (item: Pick<ExpiringItem, 'kind' | 'id'>): string =>
  item.kind === 'cac_document' ? `/cac/documents?open=${item.id}` : `/documents?open=${item.id}`;
